//import errorHandler from './errorHandler'
import api from '../../../api'
import _ from 'lodash'

export default {
    get : (payload, next) => {
        api.get('/api/v1/workspaces?user=' + payload._id, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    create : (payload, next) => {
        api.post('/api/v1/workspaces', payload, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    update : (payload, next) => {
        api.put('/api/v1/workspaces/' + payload.query.workspaceId + '/name', payload.body, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    updateAvatar : (payload, next) => {
        api.put('/api/v1/workspaces/' + payload.query.workspaceId + '/avatar', payload.formData, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    updateColor : (payload, next) => {
        api.put('/api/v1/workspaces/' + payload.query.workspaceId + '/color', payload.body, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    delete : (payload, next) => {
        api.delete('/api/v1/workspaces/' + payload.query.workspaceId, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    avatar : (payload, next) => {
        api.get('/api/v1/workspaces/' + payload.query.workspaceId + '/avatar', (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    updateTagColor : (payload, next) => {
        api.put('/api/v1/workspaces/' + payload.query.workspaceId + '/usertags/' + payload.query.tagId, payload.body, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    }
} 




// WEBPACK FOOTER //
// ./src/libs/system/services/workspaces.js